/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.2.3 src/assets/3D/photography.glb -t
*/

import * as THREE from 'three'
import React, { useRef } from 'react'
import { Bounds, useGLTF } from '@react-three/drei'
import { GLTF } from 'three-stdlib'
import { frontBasicMaterial } from '../utils/materials'

type GLTFResult = GLTF & {
  nodes: {
    table: THREE.Mesh
    lamp: THREE.Mesh
  }
}

export function Photography(props: JSX.IntrinsicElements['group']) {
  const { nodes } = useGLTF(require('../assets/3D/photography.glb')) as GLTFResult
  return (
    <group {...props} dispose={null}>
      <mesh geometry={nodes.table.geometry} material={frontBasicMaterial} />
      <mesh geometry={nodes.lamp.geometry} material={frontBasicMaterial} />
    </group>
  )
}

useGLTF.preload(require('../assets/3D/photography.glb'))
